import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=2fdd4a14"
import script from "./messages.ts?vue&type=script&lang=js&external"
export * from "./messages.ts?vue&type=script&lang=js&external"
import style0 from "./messages.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports